import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGatewayResponse } from '@/Module/Core/Model/ApiModel';
import type { IShadPaymentRequest, IShadPaymentResponse } from '@/Module/Subscription/Model/ApiModel';
import { SubscriptionService } from '@/Module/Subscription/Service';

export const shadPaymentRequestAction = createAsyncThunk<IGatewayResponse<IShadPaymentResponse>, IShadPaymentRequest>(
  'subscription/shad-payment-request',
  async req => {
    return SubscriptionService.shadPaymentRequest(req).then(({ data }) => data);
  },
);
